import { useShallow } from 'zustand/react/shallow';
import { useChallengeFormStore } from '@container/Challenge/NewChallengeForm/NewChallengeForm.store';

export const useSpecialRewardModuleStore = () =>
  useChallengeFormStore(
    useShallow((s) => ({
      companyId: s.challenge.companyId,
    })),
  );
